import { createDeformedCube, depthRatio, CUBE_PARAMS } from "./CubeBase";

// 誤り2: 高さ方向の発散遠近（側面の発散）
// 側面の後退する辺ペア（文献の辺B・C）を平行以上に開いて描く誤り（80名中56名）。
// 文献では上面より側面の発散が顕著で、上面奥の辺（辺D）の上方ずれもこれに対応する。
// デッサンを正とすると、底面は水平のまま奥に行くほど背が高くなる立体になる。
// shearValue: 0=正解(立方体), 0.5=誤り, 0.2=中間
export function createCubeModel2(shearValue, faceColors, errorEdges) {
  shearValue = shearValue !== undefined ? shearValue : 0.5;
  const half = CUBE_PARAMS.size / 2;
  return createDeformedCube((x, y, z) => [
    x,
    -half + (y + half) * (1 + shearValue * 0.4* depthRatio(z)),
    z,
  ], faceColors, errorEdges);
}
